import { useLayoutEffect, useState } from 'react';
import { TABLE_MIN_WIDTH, TABLE_WIDE_MIN_WIDTH } from './ProjectsTable';

/*
  How the projects list is shown, from the width the list really has (the sidebar may be open or
  collapsed, so the window width alone does not say it):
    'cards'  — phones, and anything narrower than TABLE_MIN_WIDTH (tablets, small laptops);
    'cards-2' — the same cards two per row, from CARD_GRID_MIN_WIDTH px (a tablet in landscape);
    'medium' — the table with narrower columns;
    'wide'   — the full table.
  Phones are always 'cards'. Until the list has been measured (or without ResizeObserver) it is
  'wide', as before. Only a change of layout re-renders the page, not every pixel of a resize.
*/
export const CARD_GRID_MIN_WIDTH = 680;

export const layoutForWidth = (width) => {
  if (!width) return 'wide';
  if (width < CARD_GRID_MIN_WIDTH) return 'cards';
  if (width < TABLE_MIN_WIDTH) return 'cards-2';
  return width < TABLE_WIDE_MIN_WIDTH ? 'medium' : 'wide';
};

export function useListLayout(ref, { isPhone = false } = {}) {
  const [layout, setLayout] = useState('wide');
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element || typeof window === 'undefined' || typeof window.ResizeObserver !== 'function') return undefined;
    const measure = () => setLayout(layoutForWidth(element.getBoundingClientRect().width));
    measure();
    const observer = new window.ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);
  return isPhone ? 'cards' : layout;
}

export default useListLayout;
